const searchEngines = [
  "daum.net",
  "eniro.se",
  "naver.com",
  "yahoo.com",
  "msn.com",
  "bing.com",
  "aol.com",
  "lycos.com",
  "ask.com",
  "altavista.com",
  "netscape.com",
  "cnn.com",
  "about.com",
  "mamma.com",
  "alltheweb.com",
  "voila.fr",
  "virgilio.it",
  "bing.com",
  "baidu.com",
  "alice.com",
  "yandex.com",
  "najdi.org.mk",
  "seznam.cz",
  "search.com",
  "onetcenter.org",
  "szukacz.pl",
  "yam.com",
  "pchome.com",
  "kvasir.no",
  "sesam.no",
  "ozu.es",
  "terra.com",
  "mynet.com",
  "ekolay.net",
  "google.co",
  "rambler.ru",
  "yandex.ru",
  "coccoc.com",
];

function parseUTM(location) {
  const params = new URLSearchParams(location.search);
  const source = params.get("utm_source");
  const medium = params.get("utm_medium");
  const content = params.get("utm_content");
  const campaign = params.get("utm_campaign");

  return {
    source,
    medium,
    content,
    campaign,
  };
}

function processUTM(params) {
  const { session } = params;
  if (
    [
      session.utm.source,
      session.utm.medium,
      session.utm.content,
      session.utm.campaign,
    ].some((v) => v !== null)
  ) {
    return {
      source: session.utm.source ?? "(none)",
      medium: session.utm.medium ?? "(none)",
      content: session.utm.content ?? "(none)",
      campaign: session.utm.campaign ?? "(none)",
    };
  } else if (
    searchEngines.some((se) => session.initialReferrer?.includes(se)) &&
    (session.initialLanding.includes("vorne.com/learn") ||
      session.initialLanding.includes("vorne.com/solutions") ||
      session.initialLanding.includes("oee.com") ||
      session.initialLanding.includes("leanproduction.com"))
  ) {
    return {
      source: session.initialReferrer,
      medium: "organic",
      content: "(none)",
      campaign: "(none)",
    };
  } else if (
    searchEngines.some((se) => session.initialReferrer?.includes(se)) &&
    session.initialLanding.includes("vorne.com")
  ) {
    return {
      source: session.initialReferrer,
      medium: "referral",
      content: "(none)",
      campaign: "(none)",
    };
  } else if (
    session.initialReferrer === "" ||
    session.initialReferrer === undefined
  ) {
    return {
      source: "(direct)",
      medium: "(none)",
      content: "(none)",
      campaign: "(none)",
    };
  } else if (
    session.initialReferrer !== undefined &&
    session.initialReferrer.length !== 0
  ) {
    return {
      source: session.initialReferrer,
      medium: "referral",
      content: "(none)",
      campaign: "(none)",
    };
  } else {
    return {
      source: "(none)",
      medium: "(none)",
      content: "(none)",
      campaign: "(none)",
    };
  }
}

export { parseUTM, processUTM };
